import { Toaster } from 'react-hot-toast';
import AppRouter from './router';

function App() {
  return (
    <>
      <Toaster />
      <AppRouter />
    </>
  );
}

export default App;
